import { VehicleSelectionWidget } from 'components/FormWidgets';

const uiSchema = () => ({
  vehicle_ids: {
    'ui:widget': VehicleSelectionWidget,
    'ui:options': {
      initFilter: { type_ids: ['1', '2', '3', '4'] },
      xs: 12,
      sm: 12,
      md: 12,
      lg: 12,
      xl: 12,
    },
  },
});

export default uiSchema;
